import { Component, Prop, Vue } from 'vue-property-decorator';
import { PlantingOutgo, PlantingOutgoDetail } from '@/types/Component';
import { CsvDownload, PlantingOutgoGet } from '@/types/APIResponse';
import moment from 'moment';
import { toCamel } from "snake-camel";

@Component({
    filters: {
        changeNumberFormat(value: number): string | null {
            return Math.round(value).toLocaleString().replace(/^-/, '▲')
        }
    }
})

export default class IncomeAndOutgoPlantingOutgoDetail extends Vue {
    @Prop()
    private cropId!: string

    @Prop()
    private plantingId!: string

    private responseItem: PlantingOutgo | null = null
    private sortByAmountAsc = false
    private sortByDateAsc = false;
    private sortBySubjectAsc = false;
    private parentPath = `/aggregation/income-and-outgo/crops/${this.cropId}`
    private sortType = ""

    @Prop()
    private startDate!: string
    @Prop()
    private endDate!: string

    created(): void {
        this.getOutgo()
    }

    changeQuantityFormat(quantity: number, subject: string, unitName: string): string | null {
        switch(subject) {
            case '雇用費':
                return moment.utc().hours(0).minutes(0).add(quantity, 'm').format("H時間m分");
            case '動力光熱費':
                return moment.utc().hours(0).minutes(0).add(quantity, 'm').format("H時間m分");
            case '農薬衛生費':
                return `${quantity.toString()}${unitName}`
            case '肥料費':
                return `${quantity.toString()}${unitName}`
            case '資材費（消耗品）':
                return `${quantity.toString()}`
            case '種苗費':
                return `${quantity ? quantity.toString() : 0}${unitName}`
            default:
                return `${quantity.toString()}${unitName}`
        }
    }

    private getOutgo(): void {
        this.$apiClient.doRequest('get', `/admin/income_and_outgo/crops/outgo/${this.plantingId}?start_date=${this.startDate}&end_date=${this.endDate}`).then((ret: PlantingOutgoGet) => {
            this.responseItem = toCamel(ret) as PlantingOutgo
            this.sortByDate();
        })
    }

    private sortByAmount(): void {
        this.sortByAmountAsc = !this.sortByAmountAsc
        this.responseItem?.details.sort((a, b) => this.sortByAmountAsc ?
            a.amount - b.amount : b.amount - a.amount)
    }

    private sortDateClicked() {
        this.sortByDateAsc = !this.sortByDateAsc;
        this.sortByDate();
    }

    private sortByDate() {
        this.responseItem?.details.sort((a, b) =>
            this.sortByDateAsc ? Date.parse(a.workDate!) - Date.parse(b.workDate!) : Date.parse(b.workDate!) - Date.parse(a.workDate!)
        )
    }

    private compare(a: PlantingOutgoDetail, b: PlantingOutgoDetail) {
        if (this.sortByDateAsc) {
            if (Date.parse(a.workDate) < Date.parse(b.workDate)) return -1;
            if (Date.parse(a.workDate) > Date.parse(b.workDate)) return 1;
            if (a.subject.localeCompare(b.subject, 'ja') < b.subject.localeCompare(a.subject, 'ja')) return -1;
            if (a.subject.localeCompare(b.subject, 'ja') > b.subject.localeCompare(a.subject, 'ja')) return 1;
        } else {
            if (Date.parse(b.workDate) < Date.parse(a.workDate)) return -1;
            if (Date.parse(b.workDate) > Date.parse(a.workDate)) return 1;
            if (b.subject.localeCompare(a.subject, 'ja') < a.subject.localeCompare(b.subject, 'ja')) return -1;
            if (b.subject.localeCompare(a.subject, 'ja') > a.subject.localeCompare(b.subject, 'ja')) return 1;
        }
        return 1;
    }

    private sortBySubject() {
        this.sortBySubjectAsc = !this.sortBySubjectAsc;
        this.responseItem?.details.sort((a, b) => this.sortBySubjectAsc ?
            a.subject.localeCompare(b.subject, 'ja') : b.subject.localeCompare(a.subject, "ja")
        )
    }

    private exportCsv(): void {
        this.$apiClient.getRequest(`/admin/income_and_outgo/crops/outgo/${this.plantingId}/csv_export?start_date=${this.startDate}&end_date=${this.endDate}`).then((res: CsvDownload) => {
            this.$apiClient.csvDownload(res)
        })
    }
    openSideBar = () => {
        const isResponsive = window.matchMedia('(max-width: 1000px)').matches;
        if (!isResponsive) {
            return;
        }
        if (document.body.classList.contains('sideopen')) {
            document.body.classList.remove('sideopen')
        } else {
            document.body.classList.add('sideopen')
        }
    }
    sortByDateOrAmount() {
        switch (this.sortType) {
            case "date":
                this.sortDateClicked()
                break
            case "amount":
                this.sortByAmount()
                break
            case "subject":
                this.sortBySubject()
                break
        }
    }
}